"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconVp = void 0;
var React = __importStar(require("react"));
var IconVp = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M10.2354,7 L12.4704,7 L8.1764,14.427 L6.2944,14.427 L2.0004,7 L4.2354,7 C4.2354,7 6.7644,11.386 7.2354,12.205 C7.7064,11.386 10.2354,7 10.2354,7 Z M20,11.3271 L20,10.0411 C20,9.5151 19.883,9.1641 19.588,8.9881 C19.412,8.8711 19.059,8.7541 18.294,8.7541 L16.059,8.7541 C15.294,8.7541 14.941,8.9301 14.765,9.0471 C14.471,9.2231 14.353,9.5731 14.353,10.0991 L14.353,11.3271 C14.353,11.8531 14.529,12.2051 14.765,12.3801 C14.941,12.4971 15.294,12.6141 16.059,12.6141 L18.294,12.6141 C19.059,12.6141 19.412,12.4971 19.588,12.3801 C19.883,12.2051 20,11.8531 20,11.3271 Z M20.706,7.5261 C21.588,8.0531 22,8.8711 22,10.0411 L22,11.5031 C22,12.6141 21.588,13.4911 20.706,13.9591 C20.059,14.3091 19.177,14.4851 17.941,14.4851 L16.294,14.4851 C15.529,14.4851 14.883,14.4271 14.353,14.2521 L14.353,17.0001 L12.353,17.0001 L12.353,10.7421 L12.353,10.4501 L12.353,10.0411 C12.353,8.9301 12.765,8.0531 13.588,7.5851 C14.235,7.1761 15.117,7.0001 16.294,7.0001 L17.941,7.0001 C19.177,7.0001 20.059,7.1761 20.706,7.5261 Z" }))); };
exports.IconVp = IconVp;
exports.IconVp.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconVp;
